export default __webpack_public_path__ + "static/media/simTransfer-4.d6ca7199.png";